import "@/App.css";
import MaquetteRedirect from "@/pages/MaquetteRedirect";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import SponsorsPage from "@/pages/Sponsors";
import SponsorDetail from "@/pages/SponsorDetail";
import Bilan from "@/pages/Bilan";
import Settings from "@/pages/Settings";
import { LoginPage, ForgotPage, ResetPage } from "@/pages/AuthPages";
import CreateClub from "@/pages/CreateClub";
import { LegalPage, PrivacyPage } from "@/pages/Legal";
import Landing from "@/pages/Landing";
import AdminCallbacks from "@/pages/AdminCallbacks";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

const Loading = () => <div className="min-h-screen grid place-items-center text-[#5B665F]" data-testid="app-loading">Chargement…</div>;

function Protected() {
  const { session } = useAuth();
  const { pathname } = useLocation();
  if (session === null) return <Loading />;
  if (!session) return pathname === "/" ? <Landing /> : <Navigate to="/connexion" replace />;
  if (session.user.platform_role === "admin") return pathname === "/" ? <Landing /> : <Navigate to="/admin/rappels" replace />;
  return <Layout />;
}

function AdminOnly() {
  const { session } = useAuth();
  if (session === null) return <Loading />;
  if (!session) return <Navigate to="/connexion" replace />;
  if (session.user.platform_role !== "admin") return <Navigate to="/" replace />;
  return <AdminCallbacks />;
}

function PublicOnly({ children }) {
  const { session } = useAuth();
  if (session === null) return <Loading />;
  return session ? <Navigate to={session.user.platform_role === "admin" ? "/admin/rappels" : "/"} replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/connexion" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/inscription" element={<Navigate to="/#offre" replace />} />
          <Route path="/creer-mon-club" element={<CreateClub />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPage />} />
          <Route path="/reinitialiser-mot-de-passe" element={<ResetPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/maquette/:club" element={<MaquetteRedirect />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/admin/rappels" element={<AdminOnly />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            <Route path="/sponsors/:id" element={<SponsorDetail />} />
            <Route path="/bilans" element={<SponsorsPage bilans />} />
            <Route path="/bilans/:id" element={<Bilan />} />
            <Route path="/parametres" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
